"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCounter = void 0;

var React = __importStar(require("react"));

var utils_1 = require("./utils");

var use_get_set_1 = require("./use-get-set");

function useCounter(initialValue, min, max) {
  if (initialValue === void 0) {
    initialValue = 0;
  }

  if (min === void 0) {
    min = null;
  }

  if (max === void 0) {
    max = null;
  }

  var init = utils_1.resolveHookState(initialValue);

  if (typeof min === 'number') {
    init = Math.max(init, min);
  }

  if (typeof max === 'number') {
    init = Math.min(init, max);
  }

  var _a = use_get_set_1.useGetSet(init),
      get = _a[0],
      setInteral = _a[1];

  var counter = get();
  var methods = React.useMemo(function () {
    var set = function set(nextState) {
      var prevState = get();
      var rState = utils_1.resolveHookState(nextState, prevState);

      if (prevState !== rState) {
        if (typeof min === 'number') {
          rState = Math.max(rState, min);
        }
      }

      if (typeof max === 'number') {
        rState = Math.min(rState, max);
      }

      if (prevState !== rState) {
        setInteral(rState);
      }
    };

    return {
      get: get,
      set: set,
      inc: function inc(delta) {
        if (delta === void 0) {
          delta = 1;
        }

        var rDelta = utils_1.resolveHookState(delta, get());
        set(function (num) {
          return num + rDelta;
        });
      },
      dec: function dec(delta) {
        if (delta === void 0) {
          delta = 1;
        }

        var rDelta = utils_1.resolveHookState(delta, get());
        set(function (num) {
          return num - rDelta;
        });
      },
      reset: function reset(value) {
        if (value === void 0) {
          value = init;
        }

        var rValue = utils_1.resolveHookState(value, get());
        init = rValue;
        set(rValue);
      }
    };
  }, [init, min, max]);
  return [counter, methods];
}

exports.useCounter = useCounter;